import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import { Link, useNavigate } from 'react-router-dom'
import { Category_List } from '../../../../api/category_product/Category_Product'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Loader from '../../../../loader/Loader'
import { get_Page_Seo } from '../../../../api/global/Global'
import Footer from '../../../common/footer/Footer'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser';

const All_Categories = () => {
    const navigate = useNavigate();
    const [pageSeo, set_Page_Seo] = useState({})
    const [category_list, set_Category_List] = useState([]);
    const [is_loading, set_Is_Loading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;
    const get_category_list_result_slug = localStorage.getItem("category_list_result_slug")
    // Ensure sub_category_data is always a valid array
    const validCategoryData = Array.isArray(category_list) ? category_list : [];
    // Calculate total pages safely
    const totalPages = Math.ceil(validCategoryData?.length / productsPerPage);

    useEffect(() => {
        const Handle_Get_Category_List = async () => {
            set_Is_Loading(true);
            try {
                const response = await Category_List();
                if (response?.data?.status == 200) {
                    set_Category_List(response?.data?.data?.category || []);
                    set_Is_Loading(false);
                }
            } catch (error) {
                set_Is_Loading(false);
                console.error("error", error);
            }
        };
        Handle_Get_Category_List();
    }, [])

    // Calculate products for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentCategory = validCategoryData?.slice(startIndex, startIndex + productsPerPage);

    // Handle pagination (next, prev, page number click)
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "All Category")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_Is_Loading(false);
            }
        }

        Get_Page_Seo()
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}all-categories`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}all-categories`} />
            </Helmet>
            <div>
                {/* <----- Header section's ---------> */}
                <Header />
                {
                    is_loading ? (
                        <Loader />
                    ) : (
                        <>
                            {/* <------ Category main banner section's --------> */}
                            <section className='banner-section'>
                                <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                    <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                    } className='w-full h-[300px]' />
                                </div>
                            </section>
                            <section className="gi-category py-[40px] max-[767px]:py-[0px]">
                                <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                    <div className="flex flex-wrap w-full">
                                        <div className="gi-shop-rightside min-[992px]:w-[100%] max-[767px]:pt-[30px] min-[992px]:w-[100%] min-[768px]:w-full w-full px-[12px]">
                                            <div className="gi-pro-list-top md:flex items-center justify-between text-[14px] mb-[15px]">
                                                <div className="w-full gi-grid-list text-left">
                                                    <h1 className="text-lg font-semibold text-gray-950">List of All Categories</h1>
                                                    <div className="border-b-2 border-b-black  w-[140px] mb-3"></div>
                                                </div>
                                            </div>
                                            <div className="shop-pro-content">
                                                <div className="shop-pro-inner">
                                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
                                                        {currentCategory?.map((category_result) => (
                                                            <div key={category_result?.id}
                                                                className="w-full">
                                                                <div className="gi-product-content h-full">
                                                                    <div className="gi-product-inner bg-white transition-all duration-[0.3s] ease-in-out shadow-custome rounded-[5px] hover:z-10 hover:shadow-2xl">
                                                                        <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative pt-3 md:pt-5">
                                                                            <div className="gi-pro-image">
                                                                                <Link to={`/${category_result?.slug}`} className="image productimg7 relative block">
                                                                                    <img className="main-image border border-gray-50 min-w-[150px] h-[150px] mx-auto rounded-full transition-all duration-[0.3s] ease delay-[0s]"
                                                                                        src={`${IMG_BASE_URL}${category_result?.image}`} alt={category_result?.image_alt} />
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                        <div className="gi-pro-content h-full p-[30px] pt-[0] relative z-[10] flex flex-col text-center">
                                                                            <h2 className="gi-pro-stitle mt-4 text-gray-800 uppercase text-[14px] font-semibold leading-[1.2] whitespace-nowrap overflow-hidden">
                                                                                {category_result?.title}
                                                                            </h2>
                                                                            <div className="flex flex-col mt-2 justify-center gap-4 items-center">
                                                                                <button type="button"
                                                                                    onClick={() => {
                                                                                        navigate(`/${category_result?.slug}`)
                                                                                        localStorage.setItem("category_list_result_slug", category_result?.slug);
                                                                                    }}
                                                                                    className="text-[12px] uppercase border border-gray-200 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300">View More</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Pagination Controls */}
                                                <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                    <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, validCategoryData?.length)} of {category_list?.length} item(s)</span>
                                                    <ul className="gi-pro-pagination-inner flex">
                                                        <li>
                                                            <button onClick={handlePrev} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                                Prev
                                                            </button>
                                                        </li>

                                                        {[...Array(totalPages).keys()].map((page) => (
                                                            <li key={page} className="inline-block float-left mr-[5px]">
                                                                <button
                                                                    onClick={() => handlePageChange(page + 1)}
                                                                    className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                                                                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                                                                    text-[16px] justify-center items-center rounded-[5px]
                                                                     ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                                >
                                                                    {page + 1}
                                                                </button>
                                                            </li>
                                                        ))}

                                                        <li>
                                                            <button onClick={handleNext} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                                Next
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>
                    )
                }
                <Footer />
            </div>
        </>
    )
}

export default All_Categories